import { Component, OnInit } from '@angular/core';

import { setCookie, getCookie } from './utils/geral';
import { GruposService } from './service/grupos.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  title = 'portal-app';
  favIcon: any;

  constructor(private permissaoService: GruposService) { }

  ngOnInit(): void {
    this.favIcon = document.querySelector('#favIcon');
    this.getCustomizacoes();
  }

  getCustomizacoes(): void {
    // mock tenant cookie
    // setCookie('tenant_id', '77bb9225-daad-41c3-82f4-827f401bd597');

    this.waitForTenantCookie(5000).then(async (tenant_id) => {
      if (tenant_id) {
        const customizacoes: any = await this.permissaoService.getCustomizacoes(tenant_id);
        if (customizacoes && customizacoes.length) {
          const customizacao = customizacoes[0];
          if (customizacao?.iconeUrl) this.favIcon.href = customizacao.iconeUrl;
          if (customizacao?.cor) {
            document.documentElement.style.setProperty(`--primary-color`, customizacao.cor);
          }
          return;
        }
      } else {
        document.documentElement.style.setProperty(`--primary-color`, '#0075a9');
      }
    });
  }

  waitForTenantCookie(timeoutMs: number): Promise<string | null> {
    const intervalMs = 1000;
    const maxTries = Math.ceil(timeoutMs / intervalMs);
    let tries = 0;

    return new Promise((resolve) => {
      const interval = setInterval(() => {
        const tenantId = getCookie('tenant_id');
        if (tenantId) {
          clearInterval(interval);
          resolve(tenantId);
        } else if (++tries >= maxTries) {
          clearInterval(interval);
          resolve(null);
        }
      }, intervalMs);
    });
  }
}
